import { cn } from "@/lib/utils";

interface DetailListProps {
  children: React.ReactNode;
  className?: string;
}

export function DetailList({ children, className }: DetailListProps) {
  return (
    <dl className={cn("divide-y divide-border", className)}>{children}</dl>
  );
}

interface DetailRowProps {
  label: string;
  children: React.ReactNode;
}

export function DetailRow({ label, children }: DetailRowProps) {
  return (
    <div className="flex flex-col gap-2 py-4 first:pt-0 last:pb-0">
      <dt className="text-xs font-medium text-muted-foreground">{label}</dt>
      <dd className="min-w-0 text-sm font-medium wrap-anywhere">{children}</dd>
    </div>
  );
}
